<div class="d-flex pb-2 mb-md-0">
    <div class="d-flex flex-grow-1 mb-2 mb-md-0">
        <div class="" ngbDropdown>
            <button class="btn btn-outline-primary" id="showJob" ngbDropdownToggle>{{ showJobs[showJob] | translate }}</button>
            <div ngbDropdownMenu aria-labelledby="showJob">
              <a *ngFor="let sj of showJobs | keyvalue" class="dropdown-item" [routerLink]="['.', {mode: sj.key}]"
                [replaceUrl]="true">{{ sj.value | translate }}</a>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-end">
        <div class="ml-md-2">
            <button [matMenuTriggerFor]="appMenu" class="btn btn-outline-primary dropdown-toggle"><i class="fas fa-columns text-primary"></i> {{ 'System.Columns' | translate }}</button>
            <mat-menu #appMenu="matMenu" class="py-0 no-content-pad">
                <abi-column-selector [columns]="columns" (toggled)="table.triggerColumnSave()"></abi-column-selector>
            </mat-menu>
        </div>
        <div ngbDropdown class="ml-2 d-inline-block">
            <button [matMenuTriggerFor]="actionMenu" class="btn btn-outline-primary dropdown-toggle">{{ 'System.Actions' | translate }}</button>
            <mat-menu #actionMenu="matMenu" class="py-0">
                <mat-action-list>
                    <abi-export-buttons [table]="table" [totalResults]="totalResults" [rowsObservable]="allData()"></abi-export-buttons>
                    <mat-divider></mat-divider>
                    <abi-web-layout [pageId]="pageName" [columns]="columns" [extras]="layoutExtras.bind(this)" [layoutId]="layoutId" [layouts]="layouts">
                    </abi-web-layout>
                </mat-action-list>
            </mat-menu>
        </div>
    </div>
</div>


<div class="table-responsive-md">
<table [abi-table]="pageName" #table [columns]="columns" [rows]="dataList?.items" defaultSort="job.jobId"
  [layoutColumns]="layoutColumns" class="table-fixed-md table-hover table-striped table-sm" [canFilter]="true"
  [remoteData]="search.bind(this, true)" [hiddenColumns]="true" [alwaysSort]="true"
  [colsObs]="colsObs">

  <ng-template [th]="dateColumns" let-column>
    <span class="text-nowrap d-block text-truncate">{{ column.header | translate }} </span>
    <abi-date-range-filter [initialValue]="column.filter" (changeDate)="table.filter(column, $event)"></abi-date-range-filter>
  </ng-template>

  <ng-template td="job.jobId" let-value="value" let-row="row">
    <a [routerLink]="jobLink(row)">{{ row.job | job:'cleanJobId' }}</a>
  </ng-template>
  <ng-template td="job.resourceId" let-value="value" let-row="row">
    <a href="." (click)="showResource(row.job.resourceId)">{{ value }}</a>
  </ng-template>
  <ng-template td="visit.resourceId" let-value="value">
    <a href="." (click)="showResource(value)">{{ value }}</a>
  </ng-template>

  <ng-template td="job.contact" let-value="value" let-row="row">
    <a class="text-truncate d-inline-block w-99" [routerLink]="jobLink(row)">{{ value }}</a>
  </ng-template>
  <ng-template td="job.contact.mobile" let-value="value">
    <span class="d-md-table-cell d-none" [abiTelephone]="value"></span>
    <span class="d-table-cell d-md-none">
      <a class="btn btn-sm btn-outline-secondary text-success" [href]="'tel:' + value">
        <i class="fas fa-fw fa-phone"></i>
      </a>
    </span>
  </ng-template>

  <ng-template td="job.invoiceCustomer" let-value="value">
    <span [abiTelephone]="value"></span>
  </ng-template>

    <ng-template [td]="['price', 'price-excl', 'price-incl', 'paid', 'unpaid']" let-value="value">
        {{ value | nozero: "1.2-2" }}
    </ng-template>
</table>
</div>

<abi-pager
[pageName]="pageName" [pageNumber]="paged?.pageNumber || 1" [totalResults]="totalResults" [pagedO]="pagedS"></abi-pager>
